module.exports = __webpack_public_path__ + "static/media/George.6087d4a9.png";